import Skeleton from 'react-loading-skeleton';
import cx from 'classnames';
import { Text } from '@intellecteu/common-ui';
import { ACTIVE, INACTIVE } from 'app/constants';
import { ParticipantStatusDto } from 'data';
import { InfoCardItem } from '../item';

import s from './styles.module.scss';

type Props = {
  isStatusLoading: boolean;
  serviceUnavailable: string | null;
  healthStatus?: ParticipantStatusDto;
};

export const InfoCardHealthItem = ({ isStatusLoading, serviceUnavailable, healthStatus }: Props) => {
  const statusContent = isStatusLoading ? (
    <Skeleton height={25} width={70} borderRadius={15} />
  ) : (
    <>
      <div
        className={cx(
          s.healthItemContentStatus,
          healthStatus?.active ? s.healthItemContentStatusSuccess : s.healthItemContentStatusInfo,
        )}
      />
      <Text>{healthStatus?.active ? ACTIVE : INACTIVE}</Text>
    </>
  );

  return (
    <InfoCardItem
      value={
        <div className={s.healthItemContent}>
          {serviceUnavailable ? (
            <>
              <div className={cx(s.healthItemContentStatus, s.healthItemContentStatusError)} />
              <Text>Unavailable</Text>
            </>
          ) : (
            statusContent
          )}
        </div>
      }
    />
  );
};
